(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('DuplicatedKeycardModalController', DuplicatedKeycardModalController);


    DuplicatedKeycardModalController.$inject = [
        '$scope',
        '$windowInstance',
        'duplicatedCards',
        'accessItemGroups',
    ];

    function DuplicatedKeycardModalController(
        $scope,
        $windowInstance,
        duplicatedCards,
        accessItemGroups
    ) {

        $scope.duplicatedCards = duplicatedCards;

        $scope.close = close;
        $scope.getGroupName = getGroupName;

        function close() {
            event.preventDefault();
            $windowInstance.close(false);
        }

        function getGroupName(groupId) {
            return accessItemGroups.find(g => g.id === groupId).name;
        }
    }

})();